import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import PRCategoryForm from '@app/components/apps/PRCategories/PRCategoryForm';

export const EditPRCategoryPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Product Registration Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/product-registrations-categories',
      breadcrumbName: 'Product Registrations Categories',
    },
    {
      path: '/edit-product-registrations-category',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);
  return (
    <>
      <Row gutter={[16, 16]}>
        <PRCategoryForm
          type={'edit'}
          editable={true}
          id={id}
          pageTitle={`Edit Product Registration Category`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default EditPRCategoryPage;
